export const creditCardPayUp = {
    payUpFeature: {
        enabled: true,
        _description: 'Enables display of the refactored credit card pay up focus page',
    },
    filterForAccountsWithCardRepayment: {
        enabled: false,
        _description: 'Shows only accounts with cardRepayment flag in pay up dropdown',
    },
};
